(() => {
  const SELECTOR = '[data-autoplay-video]';

  function setState(wrapper, video) {
    wrapper.classList.toggle('is-muted', video.muted);
    wrapper.classList.toggle('is-paused', video.paused);
  }

  async function safePlay(video) {
    try {
      await video.play();
    } catch (_) {
      // Autoplay can be blocked; user can start via play button.
    }
  }

  function initWrapper(wrapper) {
    if (!(wrapper instanceof HTMLElement)) return;
    if (wrapper.dataset.autoplayVideoInitialized === 'true') return;

    const video = wrapper.querySelector('video');
    if (!(video instanceof HTMLVideoElement)) return;

    wrapper.dataset.autoplayVideoInitialized = 'true';

    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    setState(wrapper, video);

    const onToggleMute = () => {
      video.muted = !video.muted;
      setState(wrapper, video);
    };

    const onTogglePlay = async () => {
      if (video.paused) {
        await safePlay(video);
      } else {
        video.pause();
      }
      setState(wrapper, video);
    };

    wrapper.addEventListener('click', (e) => {
      const btn = e.target instanceof Element ? e.target.closest('[data-action]') : null;
      if (!(btn instanceof HTMLElement)) return;

      const action = btn.dataset.action;
      if (action === 'toggle-mute') onToggleMute();
      if (action === 'toggle-play') onTogglePlay();
    });

    video.addEventListener('play', () => setState(wrapper, video));
    video.addEventListener('pause', () => setState(wrapper, video));
    video.addEventListener('volumechange', () => setState(wrapper, video));

    safePlay(video).finally(() => setState(wrapper, video));
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initWrapper);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (event) => {
    const target = event?.target;
    if (target instanceof HTMLElement) initAll(target);
  });
})();

